import styled from 'styled-components'
import { tokens } from '@arvoreeducacao/bonsai-ds'
import { Player } from '@lottiefiles/react-lottie-player'

export const LoadingText = styled.h2`
  margin-top: 100px;
  color: ${tokens.colors.dark6};
  font-size: ${tokens.fontSize.xxlarge};
  font-weight: ${tokens.fontWeights.bold};
  line-height: ${tokens.lineHeight.medium}%;

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    margin-top: 120px;
  }
`

export const PlayerContainer = styled.div`
  position: relative;
  width: 160px;
  height: 0px;
`

export const StyledPlayer = styled(Player)`
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;

  @media (min-width: ${tokens.breakpoints.desktop}px) {
    top: ${tokens.spacing.spacing_24}px;
  }
`
